var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.367,
    height: 74.528,
    viewBox: "0 0 71.367 74.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M155.388,2.936a2.633,2.633,0,0,0-3.5-1.259,22.111,22.111,0,0,0-5.645,3.938,30.9,30.9,0,0,1,9.31-2.229A2.637,2.637,0,0,0,155.388,2.936Z",
    transform: "translate(-98.117 -0.956)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M124.625,42.891a33.69,33.69,0,0,1,3-4.98q-.867.443-1.72.938a34.113,34.113,0,0,0-7.633,5.974l4.214-.4a2.639,2.639,0,0,0,2.143-1.527Z",
    transform: "translate(-79.35 -25.436)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M31.94,159.022a4.069,4.069,0,0,0,8.137,0V132.064L31.94,136.79Z",
    transform: "translate(-21.43 -88.606)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M36.342,104.259c-1.274-.974-2.768-2.041-4.4-3.127v5.683Z",
    transform: "translate(-21.43 -67.853)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M71.638,114.6l-1.915,1.112a5.4,5.4,0,0,1,.045.7,3.393,3.393,0,0,1-3.389,3.389,3.346,3.346,0,0,1-1.063-.176l5.915,28.137a4.069,4.069,0,0,0,7.963-1.674l-6.752-32.116A3.862,3.862,0,0,1,71.638,114.6Z",
    transform: "translate(-43.823 -76.469)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M63.031,6.6a2.671,2.671,0,0,1,1.825-.953q.121-.011.24-.011a2.67,2.67,0,0,1,2.459,1.6l1.073-.1A2.694,2.694,0,0,1,71,5.1c.081-.007.161-.011.24-.011a2.7,2.7,0,0,1,1.178.27A7.4,7.4,0,0,0,57.933,8.092l4.549-.4A2.676,2.676,0,0,1,63.031,6.6Z",
    transform: "translate(-38.848 0)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M72.409,26.489a2.7,2.7,0,0,1-.636.138q-.121.011-.24.011h0a2.675,2.675,0,0,1-2.678-2.452c0-.028,0-.055,0-.082l-.795.071c0,.027.009.054.011.082a2.694,2.694,0,0,1-2.441,2.918q-.121.011-.24.011h0a2.675,2.675,0,0,1-2.678-2.452c0-.028,0-.055,0-.082l-4.366.388a7.406,7.406,0,0,0,14.069,1.45Z",
    transform: "translate(-39.142 -16.171)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M94.666,21.612a1.933,1.933,0,1,0-2.1-1.754A1.933,1.933,0,0,0,94.666,21.612Z",
    transform: "translate(-62.102 -11.911)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M75.647,19.423a1.933,1.933,0,1,0,2.1,1.754A1.933,1.933,0,0,0,75.647,19.423Z",
    transform: "translate(-49.572 -13.026)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M19.191,115.913a16.054,16.054,0,0,0-3.439-3.293L1.434,120.936A2.88,2.88,0,0,0,.39,124.873l.121.207a2.88,2.88,0,0,0,3.937,1.044l15.228-8.844a3.35,3.35,0,0,1-.484-1.367Z",
    transform: "translate(0 -75.561)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M113.909,28.676c2.508-4.148,2.95-8.049,1.247-10.983l-1.8-3.095c-1.7-2.934-5.319-4.484-10.157-4.36A32.43,32.43,0,0,0,88.24,14.906,32.429,32.429,0,0,0,76.772,25.587c-2.508,4.149-2.95,8.049-1.246,10.984.027.046.058.088.085.134L71.865,38.88a2.876,2.876,0,0,0-2.75.076l-2.33,1.353c2.19,1.978,3.244,3.483,3.688,4.8l1.655-.961a2.876,2.876,0,0,0,1.428-2.351L77.3,39.619c.009.015.015.031.024.046,1.642,2.827,5.049,4.367,9.629,4.367.174,0,.351,0,.529-.007a32.43,32.43,0,0,0,14.961-4.668A32.427,32.427,0,0,0,113.909,28.676ZM99.817,34.84C91.168,39.863,82.03,40.705,78.1,37.147c-1.141-5.18,4.118-12.7,12.767-17.723,5.118-2.973,10.408-4.482,14.689-4.482,2.95,0,5.418.72,7.024,2.169.468,2.16-.166,4.795-1.874,7.62A30.768,30.768,0,0,1,99.817,34.84Z",
    transform: "translate(-44.808 -6.864)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M127.2,43.987c-7.31,4.706-15.335,5.372-18.376,1.644a5.178,5.178,0,0,0,.285.51c2.735,4.248,11.118,3.723,18.723-1.174s11.553-12.31,8.818-16.558c-.084-.13-.178-.25-.273-.37-.026-.033-.048-.069-.074-.1.016.031.028.064.042.1,2.033,4.319-1.887,11.28-9.145,15.953Z",
    transform: "translate(-73.015 -18.745)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M18.237,55.479C24.563,59.243,30.6,63.9,31.3,65.535a2.633,2.633,0,0,0,5.258-.2c0-1.865-1-4.311-8.268-9.541-2.091-1.5-4.162-2.849-5.573-3.737a27.44,27.44,0,0,1,3.162-6.88l.675.368a24.759,24.759,0,0,0-2.927,6.193c1.365.868,3.225,2.09,5.1,3.442,1.522,1.1,2.784,2.077,3.83,2.968l2.617-1.52a3.861,3.861,0,0,1,1.936-.523,3.9,3.9,0,0,1,1.235.2l2.04-1.184.2-.93c-1.08-3.036-.43-6.734,1.9-10.59a25.9,25.9,0,0,1,2.673-3.622l-4.4.422a8.07,8.07,0,0,1-2.93.556,8.224,8.224,0,0,1-1.627-.164,8.1,8.1,0,0,1-4.02-2.1L28.424,37.9a2.548,2.548,0,0,0-.478-.053l-.028,0h-.01a2.622,2.622,0,0,0-1.008.129,10.313,10.313,0,0,0-5.654,4.675,39.119,39.119,0,0,0-4.183,9.8,2.633,2.633,0,0,0,1.172,3.032Z",
    transform: "translate(-11.372 -25.389)",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchResult);
export default __webpack_public_path__ + "static/media/searchResult.abb1a0f121c72388ec062e66cb052f0c.svg";
export { ForwardRef as ReactComponent };